module.exports = __webpack_public_path__ + "static/img/case_tab_04.c656917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_04.png
// module id = osNj
// module chunks = 34